import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from '../../components/loader';
import Instant from './index';

class InstantPrereq extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { assets, pairs } = this.props;

    const otcReady = (pairs && Object.keys(pairs).length) && (assets && assets.length);

    if (otcReady) {
      return (
        <Instant />
      );
    }
    return (
      <div>
        <div className="grid-x quick-trade">
          <div className="cell panel small-12 medium-8 large-6">
            <div className="center-loader">
              <Loader logo />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
});

export default withRouter(connect(mapStateToProps)(InstantPrereq));
